import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import ProductsPage from '@/pages/products/page';
import ProductDetailPage from '@/pages/product/page';
import CheckoutPage from '@/pages/checkout/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/product/:id', element: <ProductDetailPage /> },
  { path: '/checkout', element: <CheckoutPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
